<div ref="eBody" class="ag-tabs-body ag-menu-body">
  @if (isVisible) {
    <div class="ag-filter">
      <div>
        @if (enableArchiveSearch) {
          <div class="ag-filter-archived">
            <div>
              <p-checkbox name="isArchive" id="isArchivedData" [(ngModel)]="useArchivedData" binary="true"
              (onChange)="isArchivedDataOnChange($event)"></p-checkbox>
              <label for="isArchivedData">Older than 30 days</label>
              <span class="infoIcon archivedDataInfo"
                tooltip [tooltipPosition]="'bottom'"
              [tooltipTitle]="'To view orders that were closed more than 30 days ago, select the checkbox. (Note: orders closed 30 days or less will not be displayed.)'"></span>
            </div>
          </div>
        }
        <div class="ag-filter-body-wrapper ag-simple-filter-body-wrapper">
          <div class="ag-filter-body" ref="eCondition1Body">
            <div class="ag-filter-from ag-filter-date-from" ref="eCondition1PanelFrom">
              <div class="ag-filter-filter">
                <!--AG-INPUT-TEXT-FIELD-->
                <div role="presentation"
                  class="ag-date-filter ag-labeled ag-label-align-left ag-text-field ag-input-field" ref="eDateInput">
                  <label ref="eLabel" class="ag-input-field-label ag-label ag-text-field-label"
                  for="irb-ag-input-id-from">From:</label>
                  <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
                    <input ref="eInput" [(ngModel)]='fromDate' class="ag-input-field-input ag-text-field-input"
                      type="date" id="irb-ag-input-id-from" placeholder="yyyy-mm-dd" max="{{maxCalendarDate}}"
                      min="{{minCalendarDate}}">
                  </div>
                </div>
              </div>
            </div>
            <div class="ag-filter-to ag-filter-date-to" ref="eCondition1PanelTo">
              <div class="ag-filter-filter">
                <div role="presentation"
                  class="ag-date-filter ag-labeled ag-label-align-left ag-text-field ag-input-field" ref="eDateInput">
                  <label ref="eLabel" class="ag-input-field-label ag-label ag-text-field-label" style="width: 34px; text-align: right;" for="irb-ag-input-id-to">To:</label>
                  <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
                    <input ref="eInput" [(ngModel)]='toDate' class="ag-input-field-input ag-text-field-input" type="date"
                      id="irb-ag-input-id-to" placeholder="yyyy-mm-dd" max="{{maxCalendarDate}}"
                      min="{{minCalendarDate}}">
                  </div>
                </div>
              </div>
            </div>
          </div>
          @if (isDateValidationMsg) {
            <div style="color: red; padding: 3px; ">Please enter From and To dates</div>
          }
        </div>
        <div [ngClass]="(selectedBtn=='Day')?'selectedBtn':''" class="ag-filter-apply-panel dateActionBtn"
          (click)="getDate(0,'Day')">
          Day
        </div>
        <div [ngClass]="(selectedBtn=='Week')?'selectedBtn':''" class="ag-filter-apply-panel dateActionBtn"
          (click)="getDate(6,'Week')">
          Week
        </div>
        <div [ngClass]="(selectedBtn=='Month')?'selectedBtn':''" class="ag-filter-apply-panel dateActionBtn"
          (click)="getDate(30,'Month')">
          Month
        </div>
        @if (!enableArchiveSearch) {
          <div [ngClass]="(selectedBtn=='Quarter')?'selectedBtn':''"
            class="ag-filter-apply-panel dateActionBtn" (click)="getDate(89,'Quarter')">
            Quarter
          </div>
        }
        <div [ngClass]="(selectedBtn=='Year')?'selectedBtn':''" class="ag-filter-apply-panel dateActionBtn"
          (click)="getDate(364,'Year')">
          Year
        </div>
        <div class="ag-filter-apply-panel">
          <button type="button" class="ag-standard-button ag-filter-apply-panel-button" ref="resetFilterButton"
            (click)="onClearAction()">Clear
          </button>
          <button type="button" class="ag-standard-button ag-filter-apply-panel-button" ref="applyFilterButton"
            (click)="onApplyAction('Range')">Apply
          </button>
        </div>
      </div>
    </div>
  }
</div>
